import { styled } from '@mui/system';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import type { PropsWithChildren } from 'react';
import { useId } from 'react';

type Props = {
  title: string;
};

export const ClientFormSection = ({
  title,
  children,
}: PropsWithChildren<Props>) => {
  const id = useId();
  return (
    <Stack
      direction="column"
      gap={theme.spacing['3']}
      role="section"
      aria-labelledby={id}
    >
      <StyledTypography component="h3" variant="body1" id={id}>
        {title}
      </StyledTypography>
      <SpacedDivider />
      {children}
    </Stack>
  );
};

const SpacedDivider = styled(Divider)`
  margin-bottom: ${theme.spacing['4']};
`;

const StyledTypography = styled(Typography)`
  font-weight: 500;
`;
